import female1 from "@/assets/images/placeholders/female_1.svg";
import female2 from "@/assets/images/placeholders/female_2.svg";
import female3 from "@/assets/images/placeholders/female_3.svg";
import female4 from "@/assets/images/placeholders/female_4.svg";
import female5 from "@/assets/images/placeholders/female_5.svg";
import female6 from "@/assets/images/placeholders/female_6.svg";
import male1 from "@/assets/images/placeholders/male_1.svg";
import male2 from "@/assets/images/placeholders/male_2.svg";
import male3 from "@/assets/images/placeholders/male_3.svg";
import male4 from "@/assets/images/placeholders/male_4.svg";
import male5 from "@/assets/images/placeholders/male_5.svg";
import male6 from "@/assets/images/placeholders/male_6.svg";
// import defaultAvatar from "@/assets/images/placeholders/default.svg";
import defaultAvatar1 from "@/assets/images/placeholders/default_1.svg";
import defaultAvatar2 from "@/assets/images/placeholders/default_2.svg";
import defaultAvatar3 from "@/assets/images/placeholders/default_3.svg";

import MalePlaceholder from "@/assets/images/placeholders/male-profile.svg";
import FemalePlaceholder from "@/assets/images/placeholders/female-profile.svg";
import NeutralPlaceholder from "@/assets/images/placeholders/neutral-profile.svg";
import DummyLogo from "@/assets/images/lucidity-placeholder.png";

export const avatarOptions = [
  { id: "female_1", src: female1, label: "Female 1" },
  { id: "female_2", src: female2, label: "Female 2" },
  { id: "female_3", src: female3, label: "Female 3" },
  { id: "female_4", src: female4, label: "Female 4" },
  { id: "female_5", src: female5, label: "Female 5" },
  { id: "female_6", src: female6, label: "Female 6" },
  { id: "male_1", src: male1, label: "Male 1" },
  { id: "male_2", src: male2, label: "Male 2" },
  { id: "male_3", src: male3, label: "Male 3" },
  { id: "male_4", src: male4, label: "Male 4" },
  { id: "male_5", src: male5, label: "Male 5" },
  { id: "male_6", src: male6, label: "Male 6" },
  { id: "default_1", src: defaultAvatar1, label: "Default 1" },
  { id: "default_2", src: defaultAvatar2, label: "Default 2" },
  { id: "default_3", src: defaultAvatar3, label: "Default 3" },
];

export const getAvatarByIdOrDefault = (avatarId) => {
  const avatar = avatarOptions.find((avt) => avt.id === avatarId);
  return avatar?.src || DummyLogo;
};

export const getPlaceholderByGender = (gender) => {
  switch (gender?.toLowerCase()) {
    case 'male':
      return avatarOptions.find(avt => avt.id === 'default_1').src;
    case 'female':
      return avatarOptions.find(avt => avt.id === 'default_2').src;
    default:
      // Find the default avatar, assuming its ID might be 'default_1', 'default_2', 'default_3', or similar
      const defaultAvatar = avatarOptions.find(avt => avt.id.startsWith('default_3'));
      return defaultAvatar?.src || NeutralPlaceholder; // Fallback to NeutralPlaceholder if no default found
  }
};
